export default __webpack_public_path__ + "static/media/error.2117b78b.svg";